import BaseCtrl from 'edge/platform/base/BaseCtrl';
import { PhoneNumberUtil } from 'libphonenumber';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import nameUtil from 'edge/gateway/util/NameUtil';

var fn = function fn($scope, $state, $window, $q, $stateParams, ReinstatementService, $modal, ModalService, $filter, $translate, InsuranceSuiteMetadata, defaultLocaleDetails) {

    var ctrl = Object.create(BaseCtrl);

    var phoneUtils = PhoneNumberUtil.getInstance();

    ctrl.init = function () {
        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.reinstatementNumber = $stateParams.reinstatementNumber;
        /**
        * Function to retrieve Reinstatement Summary details.
        * @params{String} - Reinstatement Number
        * @returns{Object} - displays a Message in case of an error otherwise proceeds and maps the details to the $scope object.
        * @private
        **/
        $scope.loadingReinstatementPromise = ReinstatementService.retrieveReinstatementSummary($stateParams.reinstatementNumber).then(function (reinstatement) {
            if (!reinstatement.statusCode) {
                ModalService.showError('policy.common.modal.Error', 'policy.common.Error loading reinstatement summary');
                $state.go('policies.index');
            }
            $scope.quotedAfterBind = false;
            $scope.accountInfo = {};
            if (reinstatement.comment != undefined && reinstatement.comment == "Bound Requested") {
                $scope.quotedAfterBind = true;
            }
            mapReinstatementDetails(reinstatement);
            mapAccountDetails(reinstatement.policy.account);

            if ($scope.reinstatement.statusCode === 'NotTaken') {
                $scope.isNotTaken = true;
            }
        }, function () {
            ModalService.showError('policy.common.modal.Error', 'policy.common.Error loading reinstatement summary');
            $state.go('account-policy-details');
        });
        $scope.$watchGroup(['bindReinstatementPromise', 'withdrawReinstatementPromise'], function () {
            $scope.reinstatementActionPromise = $q.all([$scope.bindReinstatementPromise, $scope.withdrawReinstatementPromise]);
        });
    };
    /**
      * Function to map account details
      * @params{Object} - accountDetails.
      * @returns{Object} - If no account details exits functiontion otherwise updates the $scope object with values from passed in Object.
      * @private
      **/
    function mapAccountDetails(accountDetails) {
        if (!accountDetails) {
            return;
        }
        $scope.accountInfo.publicID = accountDetails.publicID;
        $scope.accountInfo.policySummaries = accountDetails.policySummaries;
        $scope.accountInfo.accountNumber = accountDetails.accountNumber;
        $scope.accountInfo.canCreateSub = accountDetails.canUserCreateReinstatement;

        setupAccountContactDetails(accountDetails.accountHolder);
    }
    /**
    * Function to update setup Account contact details based on passed in accountHolder
    * @params{Object} - AccountHolder
    * @returns{Object} - Updates $scope variable with values returned from the passed in object.
    * @private
    **/
    function setupAccountContactDetails(accountHolder) {
        $scope.accountInfo.subtype = accountHolder.subtype;
        if (accountHolder.subtype === 'Person') {
            $scope.accountInfo.firstName = accountHolder.firstName;
            $scope.accountInfo.lastName = accountHolder.lastName;
            $scope.accountInfo.contactName = nameUtil.getDisplayName(accountHolder, ' ');
        } else {
            $scope.accountInfo.contactName = accountHolder.contactName;
        }

        $scope.accountInfo.primaryAddress = accountHolder.primaryAddress;

        if (accountHolder.primaryPhoneType === 'work' && angular.isDefined(accountHolder.workNumber) && accountHolder.workNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.workNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'home' && angular.isDefined(accountHolder.homeNumber) && accountHolder.homeNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.homeNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'mobile' && angular.isDefined(accountHolder.cellNumber) && accountHolder.cellNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.cellNumber, defaultLocaleDetails.countryCode));
        }
    }
    /**
    * Function to update reinstatement related variables on the $scope Object
    * @params{Object} - Reinstatement transaction object
    * @returns{Object} - Updates $scope variable with values returned from the passed in object.
    * @private
    **/
    function mapReinstatementDetails(reinstatement) {
        console.log('ReinstatementDetailCtrl.mapReinstatementDetails');
        console.log('reinstatement', reinstatement);
        $scope.reinstatement = reinstatement;
        $scope.latestPeriod = reinstatement.policy.latestPeriod;
        $scope.policyNumber = reinstatement.policy.policyNumber;
        $scope.createTime = reinstatement.createTime;
        $scope.reinstatementReason = InsuranceSuiteMetadata.get('pc').types.getTypelist('ReinstateCode').getCode(reinstatement.reason).name;
        $scope.reinstatementDescription = reinstatement.description;
        // $scope.reinstatementIsDraft = reinstatement.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Draft').name;
        if (reinstatement.comment != undefined && reinstatement.comment == "Bound Requested") {
            $scope.quotedAfterBind = true;
        }
        if (!$scope.reinstatementDescription) {
            $scope.reinstatementDescription = '-';
        }
    }
    /**
    * Function to bind the Reinstatement
    * @params{String} - Reinstatement Number
    * @returns{Object} - Displays a Confirmation box for binding the reinstatement, and upon acceptance completes the process
    * @private
    **/
    ctrl.bindReinstatement = function (reinstatementNumber) {
        var message = $translate('gateway.views.reinstatement-detail.You won\'t be able to undo once bound.').then(function (msg) {
            return $translate('gateway.views.reinstatement-detail.Are you sure you want to bind this reinstatement?').then(function (secondMsg) {
                return msg + ' ' + secondMsg;
            });
        });
        var modalPromise = ModalService.showConfirm('gateway.views.reinstatement-detail.Bind Reinstatement', message, undefined, $filter('translate')('gateway.views.reinstatement-detail.Bind Reinstatement'), undefined, $filter('translate')('gateway.views.reinstatement-detail.Do Not Bind')).result;

        modalPromise.then(function () {
            $scope.bindReinstatementPromise = ReinstatementService.bindReinstatement(reinstatementNumber).then(function (reinstatement) {
                if (reinstatement.comment != undefined && reinstatement.comment == "Bound Requested") {
                    $scope.quotedAfterBind = true;
                }
                mapReinstatementDetails(reinstatement);
            }, function () {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.reinstatement-detail.Failed to bind reinstatement');
            });
        });
    };
    /**
     * Function to submit the Reinstatement
     * @params{String} - Reinstatement Number
     * @returns{Object} - Displays a Confirmation box for submitting the reinstatement, and upon acceptance completes the process
     * @private
     **/
    ctrl.submitReinstatement = function (reinstatementNumber) {
        var modalPromise = ModalService.showConfirm('policy.common.reinstatement-detail.Submit Reinstatement', $filter('translate')('policy.common.reinstatement-detail.Are you sure you want to submit the request for reinstatement?'), undefined, $filter('translate')('policy.common.reinstatement-detail.Submit Reinstatement'), undefined, $filter('translate')('policy.common.reinstatement-detail.Do Not Submit')).result;

        modalPromise.then(function () {
            $scope.submitReinstatementPromise = ReinstatementService.submitReinstatement(reinstatementNumber).then(function (reinstatement) {
                $scope.quotedAfterBind = false;
                mapReinstatementDetails(reinstatement);
            }, function () {
                ModalService.showError('policy.common.modal.Error', 'policy.common.reinstatement-detail.Failed to submit reinstatement');
            });
        });
    };
    /**
      * Function to withdraw Reinstatement transaction
      * @params{String} - Reinstatement Number
      * @returns{Object} - displays a Message in case of an error otherwise completes withdrawl process and updates Reinstatement Details
      * @private
      **/
    ctrl.withdrawReinstatement = function (reinstatementNumber) {
        var modalPromise = ModalService.showConfirm('policy.common.reinstatement-detail.Withdraw Reinstatement', $translate('policy.common.reinstatement-detail.Are you sure you want to withdraw the request for reinstatement?'), undefined, $filter('translate')('policy.common.reinstatement-detail.Withdraw Reinstatement'), undefined, $filter('translate')('policy.common.reinstatement-detail.Do Not Withdraw')).result;

        modalPromise.then(function () {
            $scope.withdrawReinstatementPromise = ReinstatementService.withdrawReinstatement(reinstatementNumber).then(function (reinstatement) {
                mapReinstatementDetails(reinstatement);
                $scope.quotedAfterBind = false;
            }, function () {
                ModalService.showError('policy.common.modal.Error', 'policy.common.reinstatement-detail.Failed to withdraw reinstatement');
            });
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$window', '$q', '$stateParams', 'ReinstatementService', '$modal', 'ModalService', '$filter', '$translate', 'InsuranceSuiteMetadata', 'defaultLocaleDetails'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/ReinstatementDetailCtrl.js
// module id = 1684
// module chunks = 0